import { Card, Descriptions, Tag } from 'antd';
import type { TenantOrder } from '@/mocks/orders';
import { ORDER_PAYMENT_STATE_COLOR, ORDER_PAYMENT_STATE_LABEL } from '../parts/constants';

interface OrderSummaryPaymentCardProps {
  order: TenantOrder;
}

/**
 * Khối "Thông tin thanh toán" đứng ngay TRÊN cụm phiếu thu ở cột giữa pop-up xem nhanh
 * (TCR-1095, góp ý tester 13/08).
 *
 * Nhãn và màu lấy từ `ORDER_PAYMENT_STATE_*` — cùng bảng mà cột "Trạng thái thanh toán" của
 * danh sách đơn dùng, nên hai nơi không thể hiện hai nhãn khác nhau cho cùng một đơn.
 */
export function OrderSummaryPaymentCard({ order }: OrderSummaryPaymentCardProps) {
  const state = order.payment_state ?? order.payment_status;

  return (
    <Card className="order-detail-card" size="small" title="Thông tin thanh toán">
      {/* `whiteSpace: nowrap` + không ép width: nhãn "Trạng thái thanh toán" dài hơn 140px nên
          bị gãy làm hai dòng, dấu hai chấm rơi lại một mình ở dòng dưới. */}
      <Descriptions
        column={1}
        size="small"
        bordered={false}
        labelStyle={{ color: '#666', whiteSpace: 'nowrap' }}
      >
        <Descriptions.Item label="Trạng thái thanh toán">
          {state ? (
            <Tag color={ORDER_PAYMENT_STATE_COLOR[state] ?? 'default'} data-testid="order-summary-payment-state">
              {ORDER_PAYMENT_STATE_LABEL[state] ?? state}
            </Tag>
          ) : (
            '---'
          )}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
}

export default OrderSummaryPaymentCard;
